import { IntlConfig } from "react-intl";

/**
 * Type of the locales.
 */
export type Locale = "en-US" | "fr-FR";

/**
 * Locale of the default messages.
 */
export const DEFAULT_LOCALE: Locale = "en-US";

/**
 * Supported locales.
 */
export type SupportedLocales = {
  [T in Locale]: string;
};

/**
 * Supported locales with label.
 */
export const SUPPORTED_LOCALES: SupportedLocales = {
  "en-US": "English",
  "fr-FR": "Français",
};

/**
 * Locale type guard.
 *
 * @param value - May be a valid locale.
 */
export function isLocale(value: any): value is Locale {
  const locale = value as Locale;

  return Object.keys(SUPPORTED_LOCALES).includes(locale);
}

/**
 * Type of the messages needed by react-intl.
 */
export type Messages = IntlConfig["messages"];

/**
 * Async function to retrieves the messages for the provided locale.
 *
 * @param locale - Locale of the wanted messages.
 */
export async function getMessages(locale: Locale): Promise<Messages> {
  try {
    const messages = await import(`../../i18n/translations/${locale}.json`);

    return messages.default;
  } catch (error) {
    throw error;
  }
}
